export default __webpack_public_path__ + "static/bytes-a04e92d12950035f0752eb018cef2759.png";